class LoginContainer {
  constructor($location, $q, $timeout, appErrorHandler, appSession) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.$timeout = $timeout;
    this.appErrorHandler = appErrorHandler;
    this.appSession = appSession;

    this.creatingSession = false;
    this.subscriptions = [];
  }
  $onInit() {
    this.subscriptions.push(this.appSession.onSessionCreationStarts(() => {
      this.creatingSession = true;
    }));

    this.subscriptions.push(this.appSession.onSessionCreationFinishes(() => {
      this.creatingSession = false;
    }));

    this.appSession.authenticate(this.sessionExpired)
    .then(() => {
      this.$timeout(() => this.$location.path('/'));
    })
    .catch((error) => {
      this.appErrorHandler.handle(error);
    });
  }
  $onDestroy() {
    this.subscriptions.forEach((unsubscribeFn) => unsubscribeFn());
  }
}

export default {
  controller: LoginContainer,
  template: `
    <div class="odsSmallIndicator -fullHeight"></div>
  `,
  bindings: {
    sessionExpired: '<',
  },
};
